<script lang="ts">
  import Button from '$components/button/Button.svelte';
  import { closeModal, openModal } from '$components/bottom-sheet/index.svelte';
  import { signupPerson } from '$services/wallet/signupPerson';
  import { createWallet } from '$services/wallet/createWallet';
  import type { Address } from '$types/address';
  import FollowOnScreenPrompts from '$modals/follow-on-screen-prompts/FollowOnScreenPrompts.svelte';
  import type { Hex } from 'viem';
  import { goToTransition } from '$utils/goToTransition';
  import ModalSimple from '$components/modal/ModalSimple.svelte';

  let walletAddress: Address | undefined;

  const start = (): void => {
    createWalletAndSignup();
    openModal(FollowOnScreenPrompts, undefined);
  };

  const signupPersonProcess = async (address: Address): Promise<Hex | undefined> => {
    return await signupPerson(address);
  };

  const createWalletAndSignup = async (): Promise<void> => {
    try {
      walletAddress = await createWallet();

      if (walletAddress) {
        const userOpHash = await signupPersonProcess(walletAddress);
        if (!userOpHash) return;

        await closeModal();

        window.localStorage.setItem('metriAddress', walletAddress);
        void goToTransition('right', '/migrate');
      }
    } catch (_) {
      await closeModal();
    }
  };
</script>

<ModalSimple>
  {#snippet action()}
    <Button ariaLabel="Create V1 Account" stretched variant="secondary" onclick={start}>
      Create V1 Account
    </Button>
  {/snippet}
</ModalSimple>
